import React from 'react';
import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';
// import { styled } from '@mui/material/styles';

// const Root = styled(Box)(({ theme }) => ({


// }));

export default function BackdropLoader({ open = false, loadingText = false }) {
    return (
        <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.modal + 10 })}
            open={open}
        >
            <Box sx={{ display: 'flex', flexDirection: "column", alignItems: 'center', rowGap: 2 }}>
                <CircularProgress color="inherit" />
                {loadingText && (
                    <Typography variant="h6" sx={{ ml: 2 }}>{loadingText}</Typography>
                )}
            </Box>
        </Backdrop>
    );
}
